/* eslint-disable react/sort-comp */
import React from 'react';
import { StyleSheet } from 'react-native';
import { PropTypes } from 'prop-types';
import { Icon } from 'LocalGluons';
import pubSub from '../../../../pubSub';
import { ACTION } from '../../../../pubSub/actions';

const styles = StyleSheet.create({
    toggler: {
        width: 25,
        height: 25,
        marginTop: 20
    }
});

const FilterToggler = ({ active }) => (
    <Icon
        tintColor={active ? '#00A0DE' : '#FFFFFF'}
        style={styles.toggler}
        onPress={() => {
            pubSub.dispatch(ACTION.ON_EPG_FILTER_TOGGLER_PRESS, {});
        }}
        name="filter"
        testID="filter_button"
    />
);

FilterToggler.defaultProps = {
    active: false
};

FilterToggler.propTypes = {
    active: PropTypes.bool
};

export default FilterToggler;
